<template>
<b-container style="padding:0;">
  <div class="row header-tab">

    <b-col cols="4"><a href="https://sportips.fr"><img src="../assets/logo.png" style="width:100%;height:auto;max-width:200px;"/></a></b-col>
    <b-col cols="8"><h2 style="margin-top:15px;font-weight:black">Liste des courses</h2></b-col>


<b-col cols="6"  style="margin-top:25px;">
  <b-form-input v-model="search_terms" placeholder="Rechercher une course..." @change="launchNewSearch" ></b-form-input>
</b-col>

</div>
<b-row class="vignette_container">
  <b-col cols="2" v-for="epreuve in epreuves" class="vignette">
    <router-link target="_blank" :to="{ name: 'Epreuve', query: {id : epreuve.id} }">

    <img :src="flyer" />
    <p class="vignette_name">{{epreuve.nom_epreuve}}</p>
    </router-link>
  </b-col>
  </b-row>
  {{epreuve}}


  <!-- <b-table striped outlined hover small :items="epreuves" :fields="fields" @row-clicked="goToEpreuve">
    <template slot="nom_epreuve" slot-scope="data">
        {{data.value}}
      </template>
  </b-table> -->


</b-container>
</template>

<script>
  import axios from 'axios'
export default {

  data () {
    return {
      search_terms:"",
      flyer : "https://sportips.fr/MPV19/img/flyer.jpg",
      fields: [
          { key: 'nom_epreuve', label: 'Nom' ,sortable: true },
          { key: 'date_epreuve', label: 'Date', sortable: true },
          { key: 'ville_competition', label: 'Ville' , sortable: false }
        ],
      epreuves:[],
    }
  },
  methods :{
    launchNewSearch(){

      var _this = this;
      var data = new FormData();
      data.append("search_terms",this.search_terms);

      axios.post(`https://sportips.fr/plateformeResultats/getEpreuves.php`, data)
        .then(function(response) {

          _this.epreuves = response.data;

        });
    },
    goToEpreuve(data,index){
      this.$router.push({ name: 'Epreuve', params: { epreuve: data }});
    }
  },
  created : function(){
    var _this = this;
    var data = new FormData();
    data.append("search_terms",this.search_terms);
    axios.post(`https://sportips.fr/plateformeResultats/getEpreuves.php`, data)
      .then(function(response) {

       _this.epreuves = response.data;

      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .header-tab{
    
    background-color:#e7e7e7;
  }
  .vignette{
    margin-bottom:15px;
        cursor:pointer;
  }

  .vignette_link:hover .vignette_name{
    text-decoration:none !important;
    color:black;
  }



  .vignette img{

    width:100%;
    height:auto;
  }


  .vignette_container{
    background-color:#e7e7e7;
  }

  .vignette_name{
    background-color:orange;
    color:white;
    padding:5px;
  }
</style>
